import React, { useState, useEffect } from 'react'
import { motion } from 'framer-motion'
import { useEase } from '../components/motion'
import caption from "../hooks/cover_caption_data.json"
import { Pullstate } from "../components/pullstate"

export const Banner = (props) => {
	const[ coverLoaded, setCoverLoaded ] = useState( false );
	const [whisperEnd, setWhisperEnd] = useState(false)
	const [unmountWhisper, setUnmountWhisper] = useState(false)
	const toggleCoverLoad = () => {
		setCoverLoaded(false ? true : true)
		Pullstate.update(s => {
			s.isCoverLoaded = false ? true : true
		})
	}
	const triggerWhisperEnd = () => setWhisperEnd(false ? true : true)
	const triggerUmountWhisper = () => setUnmountWhisper( false ? true : true )

	const children = React.Children.map(props.children, (child, index) => {
		return React.cloneElement(child, {
			index,
			breakpoint: props.breakpoint,
			toggleCoverLoad,
			coverLoaded,
			whisperEnd
		})
	})

	return (
		<>
			<div className="chapter-banner">
				{children}
			</div>
			{props.caption &&
				<CoverCaption text={props.quote} theme={props.captionTheme} />
			}
		</>
	)
}

export const CoverCaption = (props) => {
	const classes = `cover-caption theme-${props.theme ? props.theme : 'light'}`
	return (
		<div className={classes}>
			<strong>Above: </strong> {caption[props.text]}
		</div>
	)
}

export const BannerContent = (props) => {
	const children = React.Children.map(props.children, (child, index) => {
		return React.cloneElement(child, {
			index,
			breakpoint: props.breakpoint,
			coverLoaded: props.coverLoaded
		})
	})
	return (
		<div className="banner-content">
			<div className='banner-content-container'>
				{children}
			</div>
			<ScrollArrow
					arrowTheme={props.arrowTheme}
					arrowPos={props.arrowPos}
					loaded={props.coverLoaded}
				/>
		</div>
	)
}

export const Subtitle = (props) => {



		const subtitleTheme = props.theme ? props.theme : ''
		const subtitleClasses = `chapter-subtitle subtitle-${subtitleTheme}`

		return (
			<div className={subtitleClasses}>
				<motion.div
					className='chapter-subtitle-bar'
					variants={subBarAnime}
					initial='closed'
					animate={props.coverLoaded ? 'open' : 'closed'}
				>
				</motion.div>
				<motion.div
					className='chapter-subtitle-number'
					variants={subNumberAnime}
					initial='closed'
					animate={props.coverLoaded ? 'open' : 'closed' }
				>
					{props.subtitleNumber}
				</motion.div>
			</div>
		)

}

const subNumberAnime = {
	closed: {
		opacity: 0,
	},
	open: {
		opacity: 1,
		transition: {
			ease: useEase('easeOutQuart'),
			duration: 0.25,
			delay: 1.25
		},
	}
}

const subBarAnime = {
	closed: {
		scaleX: 0,
	},
	open: {
		scaleX: 1,
		transition: {
			ease: useEase('easeInQuart'),
			duration: 0.255,
			delay: 1.4,
		}
	}
}

export const ScrollArrow = (props) => {
	const containerVar = {
		closed: {
			opacity: 0,
			y: 10,
		},
		open: {
			opacity: 1,
			y: 0,
			transition: {
				ease: useEase('easeOutExpo'),
				duration: 0.5,
				delay: 4,
			}
		}
	}

	const arrowVar = {
		closed: {
			y: 20,
			opacity: 0,
		},
		open: {
			y: -20,
			opacity: [0, 1, 0],
			transition: {
				repeat: Infinity,
				duration: 2,
				ease: useEase('easeOutQuad'),
			}
		}
	}

	const pos = props.arrowPos? props.arrowPos : 'center'
	const theme = props.arrowTheme? props.arrowTheme : 'dark'
	const classes = `scrollArrow scrollArrow-position-${pos} scrollArrow-theme-${theme}`

	return (
		<motion.div
			className={classes}
			variants={containerVar}
			initial="closed"
			animate={ !props.static && props.loaded ? "open" : "closed"}
		>
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 69.79">
				<g id="scrollArrow">
					<g id="arrow">
						<line
							x1="6.48"
							x2="6.48"
							y2="68"
							fill="none"
							stroke="currentColor"
						/>
						<path
							d="M2.48,62l4.06,6.81L8.19,66l2.33-4"
							fill="none"
							stroke="currentColor"
						/>
					</g>
					<motion.g id="orb" variants={arrowVar} initial="closed">
						<circle
							cx="6.5"
							cy="29"
							r="6"
							fill="none"
							stroke="currentColor"
						/>
					</motion.g>
				</g>
			</svg>
			<span>SCROLL</span>
		</motion.div>
	)
}